import httpCommon from "./http-common";

// Get all financial reports
const getAllFinancialReports = (businessId: number) => {
  return httpCommon.get(`/v1/get/financialReports/${businessId}`);
};

// Get all property reports
const getAllPropertyReports = (businessId: number) => {
  return httpCommon.get(`/v1/get/propertyReports/${businessId}`);
};

// Get all tenant reports
const getAllTenantReports = (businessId: number) => {
  return httpCommon.get(`/v1/get/tenantReports/${businessId}`);
};

// Get all maintenance reports
const getAllMaintenanceReports = (businessId: number) => {
  return httpCommon.get(`/v1/get/maintenanceReports/${businessId}`);
};

// Get all loan reports
const getAllLoanReports = (businessId: number) => {
  return httpCommon.get(`/v1/get/loanReports/${businessId}`);
};

// Get report by ID
const getReport = (reportId: string) => {
  return httpCommon.get(`/v1/get/report/${reportId}`);
};

// Get report templates
const getReportTemplates = (businessId: number, reportType: string) => {
  return httpCommon.get(`/v1/get/report-templates/${businessId}/${reportType}`);
};

// Create financial report
const createFinancialReport = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/report/financial/${businessId}`, data);
};

// Create property report
const createPropertyReport = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/report/property/${businessId}`, data);
};

// Create tenant report
const createTenantReport = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/report/tenant/${businessId}`, data);
};

// Create maintenance report
const createMaintenanceReport = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/report/maintenance/${businessId}`, data);
};

// Create loan report
const createLoanReport = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/report/loan/${businessId}`, data);
};

// Update report
const updateReport = (reportId: string, data: any) => {
  return httpCommon.put(`/v1/update/report/${reportId}`, data);
};

// Delete report
const deleteReport = (reportId: string) => {
  return httpCommon.delete(`/v1/delete/report/${reportId}`);
};

// Generate report
const generateReport = (reportId: string) => {
  return httpCommon.post(`/v1/generate/report/${reportId}`);
};

// Export report to PDF
const exportReportToPdf = (reportId: string) => {
  return httpCommon.get(`/v1/export/report/pdf/${reportId}`, { 
    responseType: 'blob' 
  });
};

// Export report to Excel
const exportReportToExcel = (reportId: string) => {
  return httpCommon.get(`/v1/export/report/excel/${reportId}`, { 
    responseType: 'blob' 
  });
};

// Archive report
const archiveReport = (reportId: string) => {
  return httpCommon.put(`/v1/archive/report/${reportId}`);
};

const ReportService = {
  getAllFinancialReports,
  getAllPropertyReports,
  getAllTenantReports,
  getAllMaintenanceReports,
  getAllLoanReports,
  getReport,
  getReportTemplates,
  createFinancialReport,
  createPropertyReport,
  createTenantReport,
  createMaintenanceReport,
  createLoanReport,
  updateReport,
  deleteReport,
  generateReport,
  exportReportToPdf,
  exportReportToExcel,
  archiveReport
};

export default ReportService; 